class DeliveryOptionsPopup extends Component {
    constructor(el) {
        super(el);
        this.opener = document.querySelector('[data-delivery-options-opener]');
        this.addEventListeners();
    }

    openPopup() {
        EventBus.getInstance().dispatchEvent('showBasePopup', 'delivery-options-popup');
    }

    addEventListeners() {
        this.opener && this.opener.addEventListener('click', () => this.openPopup());
    }
}
